<template>
    <rkm-overlay>
        <rkm-layout-body title="Requisição pendente">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.printSeparacaoMaterial()"
                    color="info"
                >
                    Separar material
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save(true)"
                    color="primary"
                >
                    Salvar e imprimir
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.sendAnswer()"
                    color="success"
                >
                    Enviar resposta
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/almoxarifado/requisicao-pendente-permissao/components/pendente/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.redirectToList()
        },
        handleSave() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'almoxarifado-requisicao-pendente-permissao-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>